import { render, staticRenderFns } from "./CorrelationListItem.vue?vue&type=template&id=33706c12&scoped=true"
import script from "./CorrelationListItem.vue?vue&type=script&lang=ts"
export * from "./CorrelationListItem.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationListItem.vue?vue&type=style&index=0&id=33706c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33706c12",
  null
  
)

export default component.exports